// extracted by mini-css-extract-plugin
module.exports = {"prev":"choose-kia-nav_prev__Y0vXz","next":"choose-kia-nav_next__dtuNa","rangeprev":"choose-kia-nav_rangeprev__MPNFS","rangenext":"choose-kia-nav_rangenext__frdCa"};